module.exports = __webpack_public_path__ + "static/media/caret-right.c418eb51.svg";